/*
 *
 * ActionPlansImport constants
 *
 */

const routeComponent = "app/containers/ActionPlansImport"

export const DEFAULT_ACTION = `${routeComponent}/DEFAULT_ACTION`

export const GET_TEMPLATE_WATCHER = `${routeComponent}/GET_TEMPLATE_WATCHER`
export const GET_TEMPLATE_FAILED = `${routeComponent}/GET_TEMPLATE_FAILED`
export const GET_TEMPLATE_SUCCESS = `${routeComponent}/GET_TEMPLATE_SUCCESS`

export const UPLOAD_TEMPLATE_WATCHER = `${routeComponent}/UPLOAD_TEMPLATE_WATCHER`
export const UPLOAD_TEMPLATE_SUCCESS = `${routeComponent}/UPLOAD_TEMPLATE_SUCCESS`
export const UPLOAD_TEMPLATE_FAILED = `${routeComponent}/UPLOAD_TEMPLATE_FAILED`
